import { FEATURE_NAMES } from '../../loaders/features/features';
export const FEATURE_NAME = FEATURE_NAMES.pageViewEvent;
export const TTFB = 'firstbyte';
export const FBTDC = 'domcontent';
export const FBTWL = 'windowload';